const standalone = window.navigator.standalone;
const userAgent = window.navigator.userAgent.toLowerCase();
const safari = /safari/.test(userAgent);
const ios = /iphone|ipod|ipad/.test(userAgent);
const isInWebAppiOS = ios && !standalone && !safari;
const isInWebAppChrome = !ios && userAgent.includes('wv');
export const isMobileStandaloneBrowser = () => {
  return isInWebAppChrome || isInWebAppiOS;
};